import { Editor, Path, Text, Transforms, Node } from 'slate';

import { CustomText, GroupingOperatorElement } from '../types';
import { selectAfterNode } from './utils';

export const groupHandlers = {
  convertToClosingParen(editor: Editor, node: any, path: any) {
    if (!node.convertToClosingParen) {
      return false;
    }

    if (!Editor.hasPath(editor, path)) return false;

    Editor.withoutNormalizing(editor, () => {
      // Remove the original marked text node
      Transforms.removeNodes(editor, { at: path });

      // Create the group structure
      const openerNode = {
        children: [{ text: '' }],
        operator: ')',
        type: 'grouping-operator',
      };

      const textNode = { text: '' };

      // Insert the new structure
      Transforms.insertNodes(
        editor,
        [openerNode as GroupingOperatorElement, textNode as CustomText],
        {
          at: path,
        },
      );

      selectAfterNode(editor, path);
    });

    return true;
  },

  // [PURPOSE]: Handles the conversion of a text node marked with 'convertToOpeningParen' (typically '(') into a 'grouping-operator' element.
  convertToOpeningParen(editor: Editor, node: any, path: any) {
    if (!node.convertToOpeningParen) {
      return false;
    }

    if (!Editor.hasPath(editor, path)) return false;

    Editor.withoutNormalizing(editor, () => {
      // Remove the original marked text node
      Transforms.removeNodes(editor, { at: path });

      // Create the group structure
      const openerNode = {
        children: [{ text: '' }],
        operator: '(',
        type: 'grouping-operator',
      };

      const textNode = { text: '' };

      // Insert the new structure
      Transforms.insertNodes(
        editor,
        [openerNode as GroupingOperatorElement, textNode as CustomText],
        {
          at: path,
        },
      );

      selectAfterNode(editor, path);
    });

    return true;
  },

  // [PURPOSE]: Detects if a text node solely contains ')' and marks it for conversion into a group ('convertToGroup: true').
  detectClosingParenthesis(editor: Editor, node: Node, path: Path) {
    if (
      !(Text.isText(node) && node.text.trim() === ')') ||
      node.convertToClosingParen ||
      node.isEditing
    ) {
      return false;
    }

    Transforms.setNodes(editor, { convertToClosingParen: true }, { at: path });

    return true;
  },

  // [PURPOSE]: Detects if a text node solely contains '(' and marks it for conversion into a group ('convertToGroup: true').
  detectOpeningParenthesis(editor: Editor, node: Node, path: Path) {
    if (
      !(Text.isText(node) && node.text.trim() === '(') ||
      node.convertToOpeningParen ||
      node.isEditing
    ) {
      return false;
    }

    Transforms.setNodes(editor, { convertToOpeningParen: true }, { at: path });

    return true;
  },
};

export default groupHandlers;
